import { RootState } from 'store/root-reducer';

export const getViolationOverloadStatistic = (state: RootState) => state.statistics.violationOverloadStatistic;
